import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-object-dropdown',
  templateUrl: './object-dropdown.component.html',
  styleUrls: ['../dropdown.component.scss']
})
export class ObjectDropdownComponent implements OnInit {
  @Input() options: Array<{ label: string, value: string }>;
  @Input() title: string;
  @Input() parentForm: FormGroup;
  @Input() parentControl: string;
  @Input() showAll: boolean;
  @Input() isDisabled: boolean;
  isDropDown: boolean;

  ngOnInit(): void {
  }

  onToggle(): void {
    this.isDropDown = !this.isDropDown;
  }

  getDisplayValue(): string {
    const currentValue = this.f[this.parentControl].value;
    if (!currentValue) return this.title || 'Izaberi';
    const option = this.options?.find(o => o.value === currentValue);
    return option ? option.label : this.title || 'Izaberi';
  }

  trackByFunction(index: number): number {
    return index;
  }

  get f() {
    return this.parentForm.controls;
  }
}
